export const transition = {duration: 0.3};

export const overlayAnimation = {
  initial: {opacity: 0},
  animate: {opacity: 1},
  exit: {opacity: 0}
};
